import React from 'react';
import { SearchIcon, ChevronDownIcon } from 'lucide-react';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface ModeToggleSelectorProps {
  pm: PM;
}
export const ModeToggleSelector: React.FC<ModeToggleSelectorProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    darkMode,
    mode,
    selectedItemId,
    showItemDropdown,
    searchQuery,
    filteredItems,
    itemDropdownRef,
    handleModeChange,
    handleItemSelect,
    setShowItemDropdown,
    setSearchQuery,
    getExistingItems
  } = pm;
  return <div className={`p-3 sm:p-4 rounded-xl mb-4 sm:mb-6 ${dk.card} shadow-sm`} data-id="element-20990" data-mp="2d787lbr6ooas">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-20991" data-mp="28fzxselxz0x3">
        <div className={`flex p-1 rounded-lg ${dk.surfaceMuted}`} data-id="element-20992" data-mp="1kqdv3h6d23kc">
          <button onClick={() => handleModeChange('create')} className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${mode === 'create' ? darkMode ? 'bg-gray-600 shadow-sm text-white' : 'bg-white shadow-sm text-gray-900' : `${dk.textMuted} hover:${dk.textSecondary}`}`} data-id="element-20993" data-mp="1kokmvxg3nba8">
            Create New
          </button>
          <button onClick={() => handleModeChange('edit')} className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${mode === 'edit' ? darkMode ? 'bg-gray-600 shadow-sm text-white' : 'bg-white shadow-sm text-gray-900' : `${dk.textMuted} hover:${dk.textSecondary}`}`} data-id="element-20994" data-mp="n11xbc1hw75c">
            Edit Existing
          </button>
        </div>
        {mode === 'edit' && <div className="relative w-full sm:w-72" ref={itemDropdownRef} data-id="element-20995" data-mp="48py2y651lzf">
            <div className={`flex items-center justify-between w-full px-4 py-2 border rounded-md cursor-pointer ${dk.inputOnCard}`} onClick={() => setShowItemDropdown(!showItemDropdown)} data-id="element-20996" data-mp="995btquc0vhx">
              <span className={`block truncate ${!selectedItemId ? dk.textMuted : ''}`} data-id="element-20997" data-mp="1kmg6ui87cyfe">
                {selectedItemId ? (() => {
              const found = getExistingItems().find(i => i.id === selectedItemId) as any;
              return found?.title || found?.name || found?.boxName || found?.displayName || 'Select Item';
            })() : 'Select item to edit...'}
              </span>
              <ChevronDownIcon className="w-4 h-4 ml-2 text-gray-500" data-id="element-20998" data-mp="36trkyc9rrh6l" />
            </div>
            {showItemDropdown && <div className={`absolute z-10 w-full mt-1 rounded-md shadow-lg max-h-60 overflow-auto ${dk.card}`} data-id="element-20999" data-mp="320gdqa11oye5">
                <div className="p-2 sticky top-0 bg-inherit z-10" data-id="element-21000" data-mp="2ab3cuntlyimu">
                  <div className="relative" data-id="element-21001" data-mp="2a8qy0jj5coe0">
                    <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-21002" data-mp="206mzq27ijfmq" />
                    <input type="text" className={`w-full pl-9 pr-3 py-1.5 text-sm rounded-md border ${dk.inputOnCard}`} placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onClick={e => e.stopPropagation()} data-id="element-21003" data-mp="24yetellyu1h3" />
                  </div>
                </div>
                {filteredItems.length > 0 ? filteredItems.map(item => <div key={item.id} className={`px-4 py-2 text-sm cursor-pointer hover:bg-purple-50 dark:hover:bg-gray-600 ${selectedItemId === item.id ? 'bg-purple-50 dark:bg-gray-600 text-purple-700 dark:text-purple-300' : ''}`} onClick={() => handleItemSelect(item.id)} data-id="element-21004" data-mp="291kyvr197omi">
                      {(item as any).title || (item as any).name || (item as any).boxName || (item as any).displayName}
                    </div>) : <div className={`px-4 py-2 text-sm ${dk.textMuted}`} data-id="element-21005" data-mp="141wohun3hvev">
                    No items found
                  </div>}
              </div>}
          </div>}
      </div>
    </div>;
};